import { createApi } from '@reduxjs/toolkit/query/react';
import { createApiConfig } from '../../../createApiConfig';

export const lmM3uResponseMessagesApi = createApi({
  reducerPath: 'lmM3uResponseMessagesApi',
  ...createApiConfig(process.env.REACT_APP_API_BASE_URL),
  tagTypes: ['M3U Response Messages'],
  endpoints: builder => ({
    getM3uResponseMessages: builder.query({
      query: (params) => ({
        url: `/links/m3u-response-messages/`,
        params,
      }),
      providesTags: ['M3U Response Messages'],
    }),

    createM3uResponseMessage: builder.mutation({
      query: (data) => ({
        url: '/links/m3u-response-messages/',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['M3U Response Messages'],
    }),
    updateM3uResponseMessage: builder.mutation({
      query: ({ id, body }) => ({
        url: `/links/m3u-response-messages/${id}/`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['M3U Response Messages'],
    }),
    getM3uResponseMessageById: builder.query({
      query: ({ id, ...params }) => ({
        url: `/links/m3u-response-messages/${id}/`,
        params,
      }),
      providesTags: ['M3U Response Messages']
    }),
  }),
});

export const {
  useGetM3uResponseMessagesQuery,
  useLazyGetM3uResponseMessagesQuery,
  useCreateM3uResponseMessageMutation,
  useUpdateM3uResponseMessageMutation,
  useGetM3uResponseMessageByIdQuery
} = lmM3uResponseMessagesApi;
